import { render, staticRenderFns } from "./TuitionAttendanceTeacher.vue?vue&type=template&id=fa683e68&"
import script from "./TuitionAttendanceTeacher.vue?vue&type=script&lang=js&"
export * from "./TuitionAttendanceTeacher.vue?vue&type=script&lang=js&"
import style0 from "./TuitionAttendanceTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports